<template>
    <div class="py-4 text-center" id="paypal-button" />
</template>

<script>
export default {
    props: ['event', 'reservationData', 'mode'],

    mounted() {
        let custObj = this;
        paypal.Button.render({
            env: process.env.MIX_PAYPAL_MODE, // Optional: specify 'sandbox' environment
            client: {
                sandbox:    process.env.MIX_PAYPAL_CLIENT_ID,
                production: process.env.MIX_PAYPAL_SECRET
            },
            locale: 'en_US',
            style: {
                size: 'large',
                color: 'gold',
                shape: 'rect',
                tagline: 'true',
                label:   'paypal'
            },
            commit: true, // Optional: show a 'Pay Now' button in the checkout flow
            payment(resolve, reject) {
                // Set up the payment here, when the buyer clicks on the button
                let returnUrl = `https://eventiosm.it/event/${custObj.event.slug}`;

                //   Here call your own API server 
                return new Promise((resolve, reject) => {
                    axios.post('/api/checkout-paypal', {
                        return_url: returnUrl,
                        amount: custObj.event.price
                    }, {'Content-Type': 'application/json'})
                    .then(res => {
                        resolve(res.data.id)
                    })
                    .catch(error => {
                        reject(error)
                    })
                })
            },
            onAuthorize(data) {
                // Execute the payment here, when the buyer approves the transaction
                return new Promise((resolve, reject) => {
                    axios.post('/api/execute-paypal',  {
                        payer_id: data.payerID,
                        payment_id: data.paymentID,
                        type: 1,
                        amount: custObj.event.price,
                        email: custObj.reservationData.email,
                        name: custObj.reservationData.name,
                        last_name:custObj.reservationData.last_name,
                        phone: custObj.reservationData.phone,
                        company: custObj.reservationData.company,
                        role: custObj.reservationData.company_role,
                        city: custObj.reservationData.city,
                        province: custObj.reservationData.province,
                        event: custObj.event.id,
                        invoice_type: custObj.reservationData.invoice_type,
                        fiscal_code: custObj.reservationData.fiscal_code,
                        vat_number: custObj.reservationData.vat_number,
                        sd_code: custObj.reservationData.sd_code,
                        address: custObj.reservationData.address,
                        mode: custObj.mode
                    }, {'Content-Type': 'application/json'})
                    .then(res => {
                        resolve(res);
                        Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: 'Payment done successfully, Please check mail for more detail!!',
                            showConfirmButton: false,
                            timer: 1500
                        })
                        window.location.reload();
                    })
                    .catch(error => {
                        reject(error);
                        Swal.fire({
                            position: 'top-end',
                            icon: 'warning',
                            title: 'Payment failed, Please try again!!',
                            showConfirmButton: false,
                            timer: 1500
                        })
                    })
                })
            }
        },'#paypal-button')
    }
}
</script>
